import type { ReactNode } from 'react'

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string
  description?: string
  action?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-5 py-12 text-center">
      <p className="text-sm font-medium text-ink-700">{title}</p>
      {description ? <p className="text-sm text-slateish-600">{description}</p> : null}
      {action}
    </div>
  )
}
